__turbopack_context__.v({
  "content": "mobile-menu-sheet-module-scss-module__QnssXW__content",
  "header": "mobile-menu-sheet-module-scss-module__QnssXW__header",
  "logout": "mobile-menu-sheet-module-scss-module__QnssXW__logout",
  "profile": "mobile-menu-sheet-module-scss-module__QnssXW__profile",
  "root": "mobile-menu-sheet-module-scss-module__QnssXW__root",
  "separator": "mobile-menu-sheet-module-scss-module__QnssXW__separator",
  "text": "mobile-menu-sheet-module-scss-module__QnssXW__text",
  "trigger": "mobile-menu-sheet-module-scss-module__QnssXW__trigger",
});
